import { em, math, rem, transparentize } from 'polished';
import { css } from 'styled-components';
import { themeOptions } from '../options';
export const addValues = (first, second) => {
  return math(`${first} + ${second}`);
};

/**
 * Creates and rgba color giving a hex and an amount
 *
 * @param color hex color
 * @param alpha number between 0 and 1
 */
export const createRGBA = (color, alpha) => {
  const calculatedAmount = 1 - alpha;
  return transparentize(calculatedAmount, color);
};
export const remCalc = value => {
  const {
    htmlFontSize
  } = themeOptions.getOptions();
  return rem(value, htmlFontSize);
};
export const emCalc = value => {
  const {
    htmlFontSize
  } = themeOptions.getOptions();
  return em(value, htmlFontSize);
};
export const listReset = /*#__PURE__*/css(["list-style-type:none;margin:0;padding:0;"]);
export { hideVisually } from 'polished';